module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('span', {
    attrs: {
      "id": "Page_ix",
      "title": "[ix]"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('table', {
    staticClass: "calibre8",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre9"
  }, [_c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("Col. Washington was in the thickest of the fight ("), _c('span', {
    attrs: {
      "href": "#/Text/Section0035#Page_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("278")]), _vm._v(")")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002"
    }
  }, [_c('i', {
    staticClass: "calibre12"
  }, [_vm._v("Frontispiece")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("Like a flash Turtle Foot was yanked backward")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#p042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      42")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("“Looking for a chance to ship, lad?”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#p086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      86")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("An instant later the bear discovered them")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#p126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      127")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("“The white men are welcome to Nancoke”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#p168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      169")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("“Stop, do not murder him!”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0028#p214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      215")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("“Got it pretty bad,” said the surgeon")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0032#p252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      252")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("“Father!” was all Dave could say")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0036#p292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      293")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0